module.exports = __webpack_public_path__ + "img/4.a62162e0.jpg";